import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import {  Link, useLocation } from "react-router-dom";

import { MdQuestionAnswer, MdEdit, MdOutlineMoreVert, MdOutlineDeleteOutline, MdOutlineContentCopy } from "react-icons/md";


import { Img } from "../../../components/Elements";
import { AppContext } from "../../../Context";
import Fetch, { Loader, dateToText, GET } from "../../../inc/Fetch";

export default function TaskList({ v, locked, type }) {

    const { t } = useTranslation();
    const location = useLocation();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [loading, setloading] = useState(false);

    const regex = /(<([^>]+)>)/gi;
    
    let allowEdit = false;
    if (userinfo?._id == v?.user?._id) {
        allowEdit = true;
    }

    if (userinfo?.userlevel >= 7) {
        allowEdit = true;
    }

    /*

    let typeVal = type ? "tasks" : "tasks_send";
    let perms = userinfo?.school?.perms?.filter(d => d?.ck == typeVal);
    console.log(perms);
    */
    
    function copyTask() {

        const conf = window.confirm(t("confirm_copy_task"));
        if (!conf) {
            return false;
        }

        setloading(true);

        Fetch("task/copy", (d) => {
            
            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {
                setopen({ error:false, short:t("tasks_sent_success") });

            }

            setloading(false);
        }, { _id: v?._id });
    }


    function deleteTask() {
        const conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloading(true);

        Fetch("task/delete", (d) => {

            if (d?.error) {
                console.log(d?.error);
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            }
            
            

            setloading(false);
        }, { _id: v?._id });
    }

    
    
    return (
        <div className={`taskList ${userinfo?._id == v?.user?._id && "myTask"}`}>
            {allowEdit && <nav>
                <a className='mainMenuVert'><MdOutlineMoreVert /></a>
                <menu>
                    <Link to={`/${v?.lesson ?  "lesson" : "task"}/new/${v?.cat?.name}/${v?._id}`}><MdEdit />تعديل</Link>
                    {userinfo?.userlevel >= 7 && <a onClick={copyTask}><MdOutlineContentCopy />نسخ</a>}
                    <a onClick={deleteTask}><MdOutlineDeleteOutline />حذف</a>
                </menu>
            </nav>}
            <Link to={userinfo?._id ? `/task/${v?._id}` : '/login'} state={!userinfo?._id ? { previousLocation: location } : false}>
                <Img src={`img/230x150/${v?.img}`} />
                <h5>{v?.title}</h5>
                <p>{v?.story?.replace(regex, " ")?.replaceAll("&nbsp;", " ")?.substring(0, 100)}</p>
            </Link>
            
            {v?.questions?.length ? 
            <ul>
                <li><MdQuestionAnswer /><b>{v?.questions?.length}</b></li>
                {userinfo?.userlevel >= 3 && <Link to={`/sendTask/${v?._id}`} state={{ previousLocation: location }} className='btn'>{t("task_start_send")}</Link>}
            </ul>: false}
            
        </div>
    )
}
